import { IconButton, Typography } from '@mui/material';
import React, { FC } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import './coe-header.component.css';
import { useLocation, useNavigate } from 'react-router-dom';
import COETabsComponent from '../general/coe-tabs/coe-tabs.component';
import COETabComponent from '../general/coe-tab/coe-tab.component';

export interface Tab {
  label: string;
  value: string;
  hide?: boolean;
}

export interface COEHeaderProps {
  title: string;
  backLocation?: string;
  loading?: boolean;
  params?: string;
  tabs?: Tab[];
}

const COEHeaderComponent: FC<COEHeaderProps> = (props) => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    props.params ? navigate(`${newValue}?${props.params}`) : navigate(newValue);
  };

  const getValue = () => {
    if (location.pathname.includes('team-management')) {
      let path = location.pathname;

      const lastIndex = path.lastIndexOf('team-management');
      if (lastIndex !== -1) {
        path = path.substring(0, lastIndex + 'team-management'.length);
      }

      return path;
    }

    return location.pathname;
  };

  return (
    <div className="header-container">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          style={{
            padding: 0,
            visibility: props.backLocation && !props.loading ? 'visible' : 'hidden',
          }}
          onClick={() => navigate(props.backLocation as string)}
        >
          <ArrowBackIosIcon />
        </IconButton>
        <Typography variant="h4">{props.title}</Typography>
      </div>
      <div style={{ marginLeft: 75 }}>
        <COETabsComponent value={getValue()} onChange={handleChange}>
          {props.tabs
            ?.filter((tab: Tab) => !tab.hide)
            .map((tab: Tab) => {
              return <COETabComponent label={tab.label} key={tab.value} value={tab.value} />;
            })}
        </COETabsComponent>
      </div>
    </div>
  );
};

export default COEHeaderComponent;
